// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ActivePanel__container___tQt92 {
	margin-bottom: 10px;
	margin-top: 15px;
	padding: 0px 30px 70px 30px;
}

.ActivePanel__panelStack___KYloy {
	position: relative;
	overflow: visible;
}

.ActivePanel__reduceOpacity___SRCfv {
	opacity: 0.25;
}

.ActivePanel__normalOpacity___pqXsE {
	opacity: 1.0;
}

.ActivePanel__title___sMfEP {
	text-align: center;
	font-weight: bold;
	color: white;
	text-shadow: 0px 0px 15px gold;
	position: relative;
	bottom: 2px;
}

.ActivePanel__showPanel___K4rwQ {
	display: block;
}

.ActivePanel__hidePanel___A_6nv {
	display: none;
}

.ActivePanel__panelActive___fQCWt {
	opacity: 1;
	will-change: opacity;
	transition: opacity 220ms ease;
}

.ActivePanel__panelActiveTransitioning___kSgs6 {
	position: absolute;
	inset: 0;
	z-index: 1;
	width: 100%;
}

.ActivePanel__panelActivePending___fvwsz {
	opacity: 0;
}

.ActivePanel__panelOutgoing___wJ5Li {
	position: absolute;
	inset: 0;
	z-index: 2;
	opacity: 1;
	pointer-events: none;
	will-change: opacity;
	transition: opacity 220ms ease;
	width: 100%;
}

.ActivePanel__panelOutgoingFading___WaPKD {
	opacity: 0;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ActivePanel__container___tQt92`,
	"panelStack": `ActivePanel__panelStack___KYloy`,
	"reduceOpacity": `ActivePanel__reduceOpacity___SRCfv`,
	"normalOpacity": `ActivePanel__normalOpacity___pqXsE`,
	"title": `ActivePanel__title___sMfEP`,
	"showPanel": `ActivePanel__showPanel___K4rwQ`,
	"hidePanel": `ActivePanel__hidePanel___A_6nv`,
	"panelActive": `ActivePanel__panelActive___fQCWt`,
	"panelActiveTransitioning": `ActivePanel__panelActiveTransitioning___kSgs6`,
	"panelActivePending": `ActivePanel__panelActivePending___fvwsz`,
	"panelOutgoing": `ActivePanel__panelOutgoing___wJ5Li`,
	"panelOutgoingFading": `ActivePanel__panelOutgoingFading___WaPKD`
};
module.exports = ___CSS_LOADER_EXPORT___;
